import classNames from 'classnames'
import { forwardRef } from 'react'
import { Spacing } from '@opallabs/gem'
import { useTheme } from '@opallabs/hooks'
import { Icon } from '../Icon'
import * as styles from './styles'
import { type CheckboxProps, propDefaults } from './types'

export { type CheckboxProps }

export const Checkbox = forwardRef<HTMLDivElement, CheckboxProps>(
  (
    {
      checked = propDefaults.checked,
      className,
      disabled = propDefaults.disabled,
      htmlId,
      labedlledbyId,
      onBlur,
      onChange,
      onFocus,
      onKeyDown,
      readOnly,
      size = propDefaults.size,
      tabIndex = propDefaults.tabIndex,
      theme: propTheme,
      value,
    },
    ref
  ) => {
    const providedTheme = useTheme()
    const theme = propTheme ?? providedTheme

    return (
      <div
        css={styles.container({ size, theme })}
        className={classNames('lapidary-checkbox', className)}
        ref={ref}
      >
        <input
          id={htmlId}
          // @hack override global styles
          className="styled"
          css={styles.checkbox({ theme, size })}
          aria-labelledby={labedlledbyId}
          type="checkbox"
          tabIndex={tabIndex}
          disabled={disabled}
          checked={checked}
          onBlur={onBlur}
          onChange={onChange}
          onFocus={onFocus}
          onKeyDown={onKeyDown}
          readOnly={readOnly}
          value={value}
        />
        {checked ? (
          <Icon
            ariaHidden
            glyph="gem-check"
            height={size - Spacing.XS}
            css={styles.icon}
            width={size - Spacing.XS}
          />
        ) : undefined}
      </div>
    )
  }
)

Checkbox.displayName = 'Lapidary: Checkbox'
